import { render, staticRenderFns } from "./CreateUpsellItemPage.vue?vue&type=template&id=1e837f34&scoped=true&"
import script from "./CreateUpsellItemPage.vue?vue&type=script&lang=js&"
export * from "./CreateUpsellItemPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpsellItemPage.vue?vue&type=style&index=0&id=1e837f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e837f34",
  null
  
)

export default component.exports